import { useEffect, useState } from "react";

// One-shot fetch of distinct valid_date values from App Search. Decoupled
// from the main SearchProvider on purpose: facet counts on the live
// search shrink as the user adds filters, which would make the
// "Valid as of" badge flicker.

const ENDPOINT =
  "https://frtv2.ent.ca-central-1.aws.elastic-cloud.com/api/as/v1/engines/frt/search.json";
const SEARCH_KEY = "search-2f7pnod8kxxe8vo7733wk7su";

let cachedPromise = null;

function pickNewest(values) {
  if (!values.length) return null;
  const sorted = [...values].sort((a, b) => {
    const ta = Date.parse(a);
    const tb = Date.parse(b);
    if (isNaN(ta) || isNaN(tb)) return a < b ? 1 : a > b ? -1 : 0;
    return tb - ta;
  });
  return sorted[0];
}

export function fetchValidDates() {
  if (cachedPromise) return cachedPromise;
  cachedPromise = fetch(ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${SEARCH_KEY}`,
    },
    body: JSON.stringify({
      query: "",
      page: { size: 1 },
      facets: { valid_date: [{ type: "value", size: 10 }] },
    }),
  })
    .then((r) => (r.ok ? r.json() : Promise.reject(new Error(`HTTP ${r.status}`))))
    .then((json) => {
      const data = json?.facets?.valid_date?.[0]?.data || [];
      const values = data.map((d) => d.value).filter(Boolean);
      return pickNewest(values);
    })
    .catch((e) => {
      console.error("validDateService: fetch failed", e);
      cachedPromise = null;
      return null;
    });
  return cachedPromise;
}

export function formatValidDate(raw) {
  const d = new Date(raw);
  if (isNaN(d)) return raw;
  // valid_date is a calendar date ("2026-06-01") — render in UTC so it
  // doesn't shift to the previous day for users west of UTC.
  return d.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    timeZone: "UTC",
  });
}

export function useValidAsOfDate() {
  const [date, setDate] = useState(null);
  useEffect(() => {
    let alive = true;
    fetchValidDates().then((d) => {
      if (alive) setDate(d);
    });
    return () => {
      alive = false;
    };
  }, []);
  return date;
}
